module.exports = {"id":"203502","name":"Bobby Reid","rating":"73","photo":"./data/images/photos/3/203502.png","club":{"name":"Bristol City","logo":"./data/images/clubs/BristolCity.png"},"positions":["BU","MC","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BobbyReid0.json
// module id = 611
// module chunks = 0